<template>
  <div class="teamHonor" :class="[getHonorClass]">
    <img class="posterBg" :src="teamHonorBg" />
    <main>
      <div class="otherStatus">
        <section>
          <h3>{{ teamInfo.teamName }}</h3>
          <address>{{ teamInfo.servicePointName }}</address>
          <!-- 战区名字 -->
          <div
            :class="[season == 'autumn' || ( year == '2024' && season == 'winter' && posterData.teamHonorStatus == 10) ? 'autumn-areaName' : 'areaName']"
            v-if="isShowWarZone">
            {{ posterData.warZone }}{{ isJinjichang ? '' : '赛区' }}
          </div>
          <img :src="winnerPic" v-if="winnerPic" :class="[isShowWarZone ? '' : 'single_winner']" />
        </section>
        <footer :class="[isJinjichang ? 'jinjichang-footer' : '']">
          <dl>
            <dt>
              {{ posterDesc }}
            </dt>
            <dd :class="[!winnerPic ? 'winner_date' : '']">
              {{ timeFormatFilter(posterData.date) }}
            </dd>
          </dl>
          <img
            src="../../../../assets/images/winterGame/poster/committeeSeal.png"
            :class="[this.season + '_' + this.year]"
          />
        </footer>
      </div>
    </main>
  </div>
</template>

<script>
import { queryseasonteamposterfrontconfig } from "@/api/winterGame";
import { timeFormatFilter, judgeTempSeason } from "@/util/util.js";
export default {
  name: "teamHonor",
  data() {
    return {
      isSpring: false,
      teamHonorBg: null,
      winnerPic: null,
      year: "",
      season: "",
      currentSeason: '',
      isShowWarZone: false,
      posterDesc: '',
      isJinjichang: false,
      cupName: '',
    };
  },
  props: {
    posterData: {
      type: Object,
      default: function () {
        return {
          realName: "",
          date: "",
          cupNumber: 0,
          posterDesc: "",
        };
      },
    },
    teamInfo: {
      type: Object,
      default: null,
    },
  },
  computed: {
    getHonorClass() {
      if (this.posterData.sched_section_name == '全国大赛-决赛') {
        return 'finals-members'
      } else if (this.posterData.sched_section_name == '全国大赛-半决赛') {
        return 'semifinals-members'
      } 
      return ''
    }
  },
  async mounted() {
    const teamInfo = JSON.parse(localStorage.getItem('teamInfo')) || {};
    this.cupName = teamInfo.cupName;
    if (teamInfo && teamInfo.currentSeasonId) {
      this.currentSeasonId = teamInfo.currentSeasonId;
      const res = await this.querySeasonTeamPosterFrontConfig(this.currentSeasonId);
      if (res.code == 0) {
        this.postData = res.data;
      } else {
        Toast(res.message);
      }
    }
    if (this.cupName) {
      this.cupName = this.cupName.replace('松鼠杯', '');
    }
    const { sched_section_name ,warZone, advancement, sched_daily_rank, name, ware_zone_rank, group_name } = this.posterData
    console.log('xxx-1', sched_section_name, ware_zone_rank, name)
    if (sched_section_name == '全国大赛-32进16') {
      if (advancement == 1 && this.postData.nationalTop16TeamImage) {
        this.teamHonorBg = this.postData.nationalTop16TeamImage;
        this.winnerPic = require(`../../../../assets/images/squirrelCup/2025/summer/poster/strong_16.png`);
        this.posterDesc = `${this.cupName}全国16强战队`
      } else {
        this.teamHonorBg = this.postData.nationalTop32TeamImage;
        this.winnerPic = require(`../../../../assets/images/squirrelCup/2025/summer/poster/strong_32.png`);
        this.posterDesc = `${this.cupName}全国32强战队`
      }
    } else if (sched_section_name == '全国大赛-16进8') {
      if (advancement == 1 && this.postData.nationalTop8TeamImage) {
        this.teamHonorBg = this.postData.nationalTop8TeamImage;
        this.winnerPic = require(`../../../../assets/images/squirrelCup/2025/summer/poster/strong_8.png`);
        this.posterDesc = `${this.cupName}全国8强战队`
      } else {
        this.teamHonorBg = this.postData.nationalTop16TeamImage;
        this.winnerPic = require(`../../../../assets/images/squirrelCup/2025/summer/poster/strong_16.png`);
        this.posterDesc = `${this.cupName}全国16强战队`
      }
    } else if (sched_section_name == '全国大赛-8进4') {
      if (advancement == 1 && this.postData.nationalCompetitionDivisionChampionImage) {
        this.teamHonorBg = this.postData.nationalCompetitionDivisionChampionImage;
        this.winnerPic = require(`../../../../assets/images/squirrelCup/2025/summer/poster/team_bj_mid_icon.png`);
        this.isShowWarZone = true;
        this.posterDesc = `${this.cupName}全国4强战队`
      } else {
        this.teamHonorBg = this.postData.nationalTop8TeamImage;
        this.winnerPic = require(`../../../../assets/images/squirrelCup/2025/summer/poster/strong_8.png`);
        this.posterDesc = `${this.cupName}全国8强战队`
      }
    } else if (sched_section_name == '全国大赛-半决赛') {
      this.teamHonorBg = this.postData.nationalCompetitionDivisionChampionImage;
      this.winnerPic = require(`../../../../assets/images/squirrelCup/2025/summer/poster/team_bj_mid_icon.png`);
      this.isShowWarZone = true;
      this.posterDesc = `${this.cupName}全国大赛${warZone}赛区冠军战队`
    } else if (sched_section_name == '全国大赛-决赛') {
      if (group_name == '冠军争夺') {
        if (advancement == 1 && this.postData.nationalChampionImage) {
          this.teamHonorBg = this.postData.nationalChampionImage;
          this.winnerPic = ''
          this.posterDesc = `${this.cupName}全国冠军战队`
        } else {
          this.teamHonorBg = this.postData.nationalRunnerUpImage;
          this.winnerPic = ''
          this.posterDesc = `${this.cupName}全国亚军战队`
        }
      } else if (group_name == '季军争夺') {  
        if (advancement == 1) {
          this.teamHonorBg = this.postData.nationalThirdPlaceImage;
          this.winnerPic = ''
          this.posterDesc = `${this.cupName}全国季军战队`
        } else {
          this.teamHonorBg = this.postData.nationalFourthPlaceImage;
          this.winnerPic = ''
          this.posterDesc = `${this.cupName}全国第四名战队`
        }
      }
    } else if (name == '全国大赛-小组赛') {
      if (advancement == 1) {
        this.teamHonorBg = this.postData.nationalTop32TeamImage;
        this.winnerPic = require(`../../../../assets/images/squirrelCup/2025/summer/poster/strong_32.png`);
        this.posterDesc = `${this.cupName}全国32强战队`
      } else {
        this.teamHonorBg = this.postData.nationalTop64TeamImage;
        this.winnerPic = require(`../../../../assets/images/squirrelCup/2025/summer/poster/strong_64.png`);
        this.posterDesc = `${this.cupName}全国64强战队`
      }
    } else if (name == '竞技场争霸赛') {
      this.isJinjichang = true;
      this.isShowWarZone = true;
      if (ware_zone_rank == 1) {
        this.teamHonorBg = this.postData.arenaRegionChampionImage;
      } else if (ware_zone_rank == 2) {
        this.teamHonorBg = this.postData.arenaRegionRunnerUpImage;
      } else if (ware_zone_rank == 3) {
        this.teamHonorBg = this.postData.arenaRegionThirdPlaceImage;
      } else {
        this.teamHonorBg = this.postData.arenaRegionChampionImage;
      }
    }
  },
  methods: {
    timeFormatFilter(date) {
      return timeFormatFilter(date);
    },
    querySeasonTeamPosterFrontConfig(currentSeasonId) {
      return new Promise((resolve, reject) => {
        queryseasonteamposterfrontconfig({
          param: {
            seasonTagId: currentSeasonId
          }
        }).then(res => {
          resolve(res);
        }).catch(err => {
          reject(err);
        })
      })
    },
  },
};
</script>

<style lang="less" scoped>
.teamHonor {
  display: flex;
  flex-direction: column;
  main {
    top: 364px;
    position: absolute;
    left: 0;
    right: 0;
    address {
      font-style: normal;
    }
  }
  
  .single_winner {
    margin-top: 80px;
  }
  .posterBg {
    width: 100%;
  }
  &.finals-members {
    .otherStatus {
      footer {
        margin-top: 40%;
        position: relative;
        dl {
          dt {
          }
          dd {
            margin-top: 20px;
            color: #ffffff;
          }
        }
        img {
          top: -3px;
        }
      }
    }
  }
  &.semifinals-members {
    .otherStatus {
      footer {
        margin-top: 20px;
        dl {
          dt {
          }
          dd {
            margin-top: 20px;
            color: #ffffff;
          }
        }
        img {
          top: 30px;
        }
      }
    }
  }
  .otherStatus {
    > img {
      width: 90%;
      margin: auto;
      display: block;
      position: absolute;
      top: 220px;
      left: 0;
      right: 0;
    }
    section {
      text-align: center;
      color: #ffffff;
      position: relative;
      margin-top: 20px;
      h3 {
        height: 66px;
        font-size: 48px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 66px;
        margin: 0 auto;
      }
      address {
        height: 44px;
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 44px;
      }
      img {
        // margin-top: 80px;
        width: 674px;
      }
      .areaName {
        margin-top: 20px;
        height: 146px;
        font-size: 104px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 146px;
        // margin-top: 50px;
      }
      .autumn-areaName {
        height: 166px;
        font-size: 104px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 146px;
        margin-top: 0px;
      }
      &:first-child {
        p {
          margin: 0;
          height: 40px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 40px;
        }
        address {
          height: 44px;
          font-size: 32px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 44px;
          font-style: normal;
        }
        h3 {
          margin-top: 16px;
          margin-bottom: 0;
          height: 98px;

          font-size: 48px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          line-height: 98px;
        }
      }
    }
    footer {
      margin-top: 20px;
      position: relative;
      // bottom: 0;
      dl {
        text-align: center;
        margin: auto;
        dt {
          height: 44px;
          font-size: 32px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: normal;
          color: #fbf497;
          line-height: 44px;
        }
        dd {
          height: 40px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FBF497;
          line-height: 40px;
          margin-left: 0;
        }
      }
      img {
        width: 259px;
        position: absolute;
        right: 10px;
      }
      .spring_2023 {
        bottom: -130px;
      }
      .summer_2023 {
        top: 240px !important;
        right: 60px !important;
      }
      &.jinjichang-footer {
        margin-top: 180px;
      }
    }
  }
}
</style>
